package team.platforma.chat_presentation

enum class Status {
    Pending,
    Sending,
    Delivered,
    Failed,
    Printing
}